<template>
  <div class='paramsPage'>
    <Left ref='left' />
    <Right />
  </div>
</template>

<script>

import Left from './Left.vue'
import Right from './Right.vue'

export default {
  components: {
    Left,
    Right
  }
}
</script>

<style lang='scss' scoped>
.paramsPage {
  height: 100%;
  display: flex;
}
</style>
